import layananService from "../../services/layananService/service";
import ServiceModel from "../../models/serviceModel/model";

export default {
    async fetchServices(search, page, limit, company) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const { data, headers } = await layananService.getLayanans(sanitizedSearch, page, limit, company);
            return {
                data: data.map(service => new ServiceModel(service)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching services:', error);
            throw error;
        }
    },

    async totalAllServices(search, company) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            return await layananService.totalAllServices(sanitizedSearch, company);
        } catch (error) {
            console.error('Error fetching services:', error);
            throw error;
        }
    },

    async addService(service) {
        try {
            return await layananService.addService(service);
        } catch (error) {
            console.error('Error adding service:', error);
            throw error;
        }
    },

    async updateService(service) {
        try {
            return await layananService.updateService(service);
        } catch (error) {
            console.error('Error updating service:', error);
            throw error;
        }
    },

    async deleteService(id) {
        try {
            return await layananService.deleteService(id);
        } catch (error) {
            console.error('Error deleting service:', error);
            throw error;
        }
    }
}